import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Button, notification, ColorPicker } from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import {
	EditFilled,
	PlusCircleFilled,
	RollbackOutlined,
} from "@ant-design/icons";
const { Text } = Typography;

const StrategyList = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [strategyList, setStrategyList] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();
	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			width: 100,
			render: (_, record) => {
				return (
					<Flex justify="space-between">
						<Button
							type="primary"
							icon={<EditFilled twoToneColor={"white"} />}
							onClick={(e) => history.push(`/strategy/update/${record.id}`)}
						/>
					</Flex>
				);
			},
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Description",
			dataIndex: "description",
			key: "description",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Color",
			dataIndex: "color",
			key: "color",
			render: (value) => {
				return <ColorPicker defaultValue={value} disabled />;
			},
		},
	];

	useEffect(() => {
		getStrategyList();
	}, []);

	const getStrategyList = async () => {
		setLoading(true);

		const url = api + `/strategy/get/list`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			if (data.success) {
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						name: item.name,
						description: item.description,
						color: item.color,
					});
				});
				setStrategyList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const addNewStrategy = () => {
		history.push("/strategy/new");
	};

	const goBack = () => {
		history.push("/followup/customer");
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Flex gap={"middle"} justify={"space-between"}>
					<Button
						type="primary"
						icon={<RollbackOutlined />}
						onClick={goBack}
						size="large"
					/>
					<Button
						onClick={addNewStrategy}
						type="primary"
						style={{
							width: 150,
						}}
						icon={<PlusCircleFilled />}
						size="large"
					>
						New Strategy
					</Button>
				</Flex>
				<CustomTable columns={columns} data={strategyList} isScroll={false} />
			</Flex>
		);
	};

	return (
		<Layout title="Strategy" description="Strategy List">
			<Flex vertical gap={"large"}>
				{loading ? <CustomSpinner /> : <RenderTable />}
				{contextHolder}
			</Flex>
		</Layout>
	);
};

export default StrategyList;
